import React from "react";
import { Link } from "react-router-dom";
import SectionHeading from "./sectionHeading";

export default function ContentCTA({ content }) {
  return (
    <div id="contentCta">
      <SectionHeading title={content.title} subtitle={content.subtitle} />
      <div className="content">
        <div className="contentLeft">
          <img src={content?.image?.url} alt="CTA" />
        </div>
        <div className="contentRight">
          <div className="description" dangerouslySetInnerHTML={{ __html: content.description }} />
          <div className="btnCta">
            <Link to={content.buttonLink}>{content.buttonText}</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
